import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import _ from 'lodash'

import { moreFilterOptions } from '../configuration/filtering'
import { useFilterTours } from './useFilterTours'
import { useSearchResults } from './useSearchResults'
import { getFilters } from '../redux/reducers/filters'

export function useGetMaxFilterOptionForMoreFiltersType(filterKey) {
  const filters = useSelector(getFilters)
  const tours = useSearchResults()

  const otherFilters = _.omit(filters, moreFilterOptions)

  const filteredTours = useFilterTours(tours, otherFilters)

  return useMemo(() => {
    let max = 0 ;
    _.forEach(filteredTours, tour => {
      const fieldValue = _.get(tour, `[${filterKey}]`)
      if (Number.isInteger(fieldValue) && fieldValue > max) {
        max = fieldValue
      }
    })
    return max
  }, [filterKey, filteredTours])
}
